module.exports = __webpack_public_path__ + "img/sec4mob.fd5cd5b2.png";